import React from 'react'
import './Footer.css'
export default function Footer() {
  return (
    <footer>2022 © ASPIRE All rights reserved</footer>
  )
}
